import React, { useState, useEffect } from 'react';
import { Snackbar, Alert, Box, Typography } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import CloudSyncIcon from '@mui/icons-material/CloudSync';

const NetworkStatus: React.FC = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showReconnected, setShowReconnected] = useState(false);
  
  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowReconnected(true);
      // Auto-hide the reconnected message after 3 seconds
      setTimeout(() => setShowReconnected(false), 3000);
    };
    
    const handleOffline = () => {
      setIsOnline(false);
    };
    
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);
  
  return (
    <>
      {/* Offline notification - stays visible while offline */}
      <Snackbar 
        open={!isOnline} 
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ bottom: { xs: 16, sm: 24 } }}
      >
        <Alert 
          icon={<WifiOffIcon />}
          severity="warning" 
          variant="filled"
          sx={{ 
            width: '100%',
            '& .MuiAlert-message': {
              display: 'flex',
              alignItems: 'center'
            }
          }}
        >
          <Typography variant="body2">
            You are currently offline. Changes will sync when connection is restored.
          </Typography>
        </Alert>
      </Snackbar>
      
      {/* Reconnected notification - shows briefly when coming back online */}
      <Snackbar 
        open={showReconnected} 
        autoHideDuration={3000}
        onClose={() => setShowReconnected(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ bottom: { xs: 16, sm: 24 } }}
      >
        <Alert 
          icon={<CloudSyncIcon />}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          Connection restored. Syncing data...
        </Alert>
      </Snackbar>
    </>
  );
};

export default NetworkStatus; 